import { Flex, Icon } from '@kandji-inc/nectar-ui';
import { i18n } from 'i18n';
import { memo } from 'react';
import type {
  CellThreatDetailProps,
  CellThreatGroupProps,
  HeaderThreatDetailProps,
  HeaderThreatGroupProps,
} from '../../../../threat.types';
import HeaderWithTooltip from '../../../components/ThreatListTable/TableHeaderWithTooltip';
import ThreatListHighlightedText from '../../ThreatListHighlightedText';
import ThreatListTextCopyButton from '../../ThreatListTextCopyButton';

export type ThreatIdHeaderProps = {
  text: string;
  isFileDetectionType: boolean;
};

export const ThreatIdHeader = ({
  text,
  isFileDetectionType,
}: ThreatIdHeaderProps) => {
  const tooltip = isFileDetectionType
    ? i18n.t('SHA-256 hash of the detected file')
    : i18n.t('Behavioral detection rule name');

  return <HeaderWithTooltip text={text} tooltip={tooltip} tooltipWidth={150} />;
};

export type ThreatIdCellProps = {
  threatId: string | undefined;
  isFileDetectionType: boolean;
  query: string | undefined;
};

export const ThreatIdCell = memo(
  ({ threatId, isFileDetectionType, query }: ThreatIdCellProps) => (
    <Flex gap="xs" alignItems="center" css={{ '& svg': { flexShrink: 0 } }}>
      {isFileDetectionType ? (
        <>
          <Icon name="file" size="sm" />
          <ThreatListTextCopyButton
            text={threatId}
            highlighted={query}
            css={{ pr: '$3' }}
          />
        </>
      ) : (
        <>
          <Icon name="gear" size="sm" />
          <ThreatListHighlightedText search={query}>
            {threatId}
          </ThreatListHighlightedText>
        </>
      )}
    </Flex>
  ),
);

export const renderThreatIdHeader = (
  info:
    | HeaderThreatDetailProps<string | undefined>
    | HeaderThreatGroupProps<string | undefined>,
  isFileDetectionType: boolean,
) => {
  const text = info.column.columnDef.meta?.displayName;
  // istanbul ignore next
  if (!text) return null;

  return (
    <ThreatIdHeader text={text} isFileDetectionType={isFileDetectionType} />
  );
};

export const renderThreatIdCell = (
  info:
    | CellThreatGroupProps<string | undefined>
    | CellThreatDetailProps<string | undefined>,
  isFileDetectionType: boolean,
  query?: string,
) => {
  const item = info.row.original;

  return (
    <ThreatIdCell
      threatId={item.threat_id}
      isFileDetectionType={isFileDetectionType}
      query={query}
    />
  );
};
